import React, { Suspense } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { message } from "antd";
import { PageLayout, LoadingLayout } from "_src/layouts";
import privateRoute from "./privateRoute";
import routes from "./routes";

message.config({
  top: 80,
});
function App() {
  return (
    <BrowserRouter>
      <PageLayout>
        <Suspense fallback={<LoadingLayout />}>
          <Switch>{privateRoute(routes())}</Switch>
        </Suspense>
      </PageLayout>
    </BrowserRouter>
  );
}

export default App;
